import { useEffect, useContext } from 'react';
import type { Editor } from '@tiptap/core';
import { AiComposerRegistryContext } from '@/lib/ai-composer/ai-composer-context';
import { WorkspaceServiceContext } from '@/lib/workspace/use-workspace-service';
import type { EditEntityKind } from '@/lib/ai-composer/types';
import { TiptapEditApplier } from '../components/tiptap-edit-applier';

export function useRegisterEditApplier(editor: Editor | null, entityKind: EditEntityKind | null) {
  // Use useContext directly (not the throwing hook) so this hook is a no-op when rendered
  // outside AiComposerProvider (e.g. in the existing rich-text-editor.test.tsx test suite).
  const registry = useContext(AiComposerRegistryContext);
  // null when no provider is mounted — embed-canvas checks at runtime.
  const workspace = useContext(WorkspaceServiceContext) ?? undefined;
  useEffect(() => {
    if (!editor || !registry || !entityKind) return;
    registry.register(new TiptapEditApplier(editor, entityKind, workspace));
    return () => {
      registry.deregister(entityKind);
    };
  }, [editor, entityKind, registry, workspace]);
}
